export const cardStyle = {
  background: "var(--surface)",
  borderRadius: "var(--radius-lg)",
  border: "1px solid var(--border)",
  padding: "20px",
  boxShadow: "var(--shadow-sm)",
};

export const PALETTE = [
  "#2563EB",
  "#10b981",
  "#f59e0b",
  "#8b5cf6",
  "#ef4444",
  "#0ea5e9",
  "#ec4899",
  "#14b8a6",
  "#f97316",
  "#6366f1",
  "#84cc16",
  "#a78bfa",
];
